import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { useIsAuthenticated } from '@/hooks/useIsAuthenticated';
import { useLogout } from '@/contexts/LogoutContext';
import { Box, CircularProgress } from '@mui/material';
import { LoginContainer } from '../../components/index.jsx';
import './Login.scss';

export const Login = () => {
	const history = useHistory();
	const isAuthenticated = useIsAuthenticated();
	const { isLoggingOut, setIsLoggingOut } = useLogout();
	const { isLoading: auth0IsLoading } = useAuth0();
	const [isCheckingAuth, setIsCheckingAuth] = useState(true);

	useEffect(() => {
		setIsLoggingOut(false);
	}, [setIsLoggingOut]);

	// Guard: If user is already authenticated, redirect to projects page
	useEffect(() => {
		// Wait for Auth0 to finish loading
		if (auth0IsLoading) {
			return;
		}

		if (isLoggingOut) {
			return;
		}

		// Check if user is authenticated (use Auth0 SDK state as source of truth)
		if (isAuthenticated) {
			// User is already authenticated, redirect to projects page
			history.replace('/home');
		} else {
			// User is not authenticated, show login page
			setIsCheckingAuth(false);
		}
	}, [history, isAuthenticated, auth0IsLoading, isLoggingOut]);

	// Show loading spinner while checking authentication to prevent flash of login page
	if (isCheckingAuth) {
		return (
			<Box
				sx={{
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					height: '100vh',
					width: '100vw',
					backgroundColor: 'white'
				}}
				data-testid="loginView"
			>
				<CircularProgress size={40} />
			</Box>
		);
	}

	return (
		<div className="loginContainer" data-testid="loginView">
			<LoginContainer />
		</div>
	);
};

export default Login;
